import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';//NECESARIO PARA TRABAJAR FORMULARIOS
import { ReactiveFormsModule } from '@angular/forms';//NECESARIO PARA TRABAJAR FORMULARIOS
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { MatLegacyButtonModule as MatButtonModule, MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySnackBarModule as MatSnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
//import { MatInputModule }/

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';

//SE REGISTRAN LOS COMPONENTES CREADOS
import { cabezote } from './components/cabezote/cabezote.component';
import { documentosSeparador } from './components/documentos-separador/documentos-separador.component';
import { separador } from './components/separador/separador.component';
import { importador } from './components/importador/importador.component';


//SE REGISTRA EL SERVICIO
import { FDLMService } from './services/FDLM.Service';

//import { HttpModule } from '@angular/http';
import { AuthGuard } from './security/auth.guard';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtInterceptor } from './security/jwt.interceptor';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { visorPdfComponent } from './components/visorPdf/visorPdf.component';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DiagsoundComponent } from './components/diagsound/diagsound.component';
import { AudioService } from './services/AudioService.service';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    cabezote,
    documentosSeparador,
    separador,
    importador,
    LoginComponent,
    visorPdfComponent,
    DiagsoundComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatDialogModule,
    MatSnackBarModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    PdfJsViewerModule,
    RouterModule.forRoot([
    { path: '', component: LoginComponent, pathMatch: 'full', canActivate: [AuthGuard] },
    { path: 'counter', component: CounterComponent, canActivate: [AuthGuard] },
    { path: 'fetch-data', component: FetchDataComponent, canActivate: [AuthGuard] },
    { path: 'separador/:vns', component: separador, canActivate: [AuthGuard] },
    { path: 'components/separador/:vns', component: separador, canActivate: [AuthGuard] },
    { path: 'separador', component: separador, canActivate: [AuthGuard] },
    { path: 'visor', component: visorPdfComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
], {}),
    BrowserAnimationsModule,
    //NgbModule,
    NgxSpinnerModule
  ],
  providers: [FDLMService,AudioService, 
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }],//aca van los servicios /:vies  pathMatch: 'full',
  bootstrap: [AppComponent]
})
export class AppModule { }
